export const FOOD_ITEM_DEFINITIONS = Object.freeze([
    {
        id: "food.canned_beans",
        name: "CANNED BEANS",
        description: "Factory-sealed food. The label is almost unreadable.",
        category: "FOOD",
        tags: ["FOOD", "ORGANIC", "METAL", "SEALED"],
        stackLimit: 6,
        unitMassGrams: 420,
        volumeMl: 450,
        longestDimensionMm: 115,
        iconKey: "can",
        worldAssetId: "small_can",
        scarcity: "COMMON",
        sortOrder: 10,
    },
    {
        id: "food.canned_peaches",
        name: "CANNED PEACHES",
        description: "A sealed can with a faded fruit label.",
        category: "FOOD",
        tags: ["FOOD", "ORGANIC", "METAL", "SEALED"],
        stackLimit: 6,
        unitMassGrams: 470,
        volumeMl: 480,
        longestDimensionMm: 120,
        iconKey: "can",
        worldAssetId: "small_can",
        scarcity: "UNCOMMON",
        sortOrder: 11,
    },
    {
        id: "food.energy_bar",
        name: "ENERGY BAR",
        description: "Dense emergency food in intact foil packaging.",
        category: "FOOD",
        tags: ["FOOD", "ORGANIC", "SEALED"],
        stackLimit: 12,
        unitMassGrams: 65,
        volumeMl: 90,
        longestDimensionMm: 110,
        iconKey: "food_bar",
        worldAssetId: "pickup_bundle",
        scarcity: "UNCOMMON",
        sortOrder: 12,
    },
]);
